import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        layout: 'start',
      },
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/recovery',
      name: 'recovery',
      meta: {
        layout: 'start',
      },
      component: () => import('./views/Recovery.vue'),
    },
    {
      path: '/change',
      name: 'change',
      meta: {
        layout: 'start',
      },
      component: () => import('./views/Change.vue'),
    },
    {
      path: '/check',
      name: 'check',
      meta: {
        layout: 'start',
      },
      component: () => import('./views/Check.vue'),
    },
    {
      path: '/activity',
      name: 'activity',
      component: () => import('./views/Activity.vue'),
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: () => import('./views/Withdrawal.vue'),
    },
    {
      path: '/withdrawal-inner',
      name: 'withdrawal-inner',
      component: () => import('./views/Withdrawal-inner.vue'),
    },
    {
      path: '/withdrawal-inner1',
      name: 'withdrawal-inner1',
      component: () => import('./views/Withdrawal-inner1.vue'),
    },
    {
      path: '/documents',
      name: 'documents',
      component: () => import('./views/Documents.vue'),
    },
    {
      path: '/unloading',
      name: 'unloading',
      component: () => import('./views/Unloading.vue'),
    },
    {
      path: '/knowledge',
      name: 'knowledge',
      component: () => import('./views/Knowledge.vue'),
    },
    {
      path: '/activity/new',
      name: 'new',
      meta: {
        child: true,
      },
      component: () => import('./views/activity/New.vue'),
    },
    {
      path: '/activity/preview',
      name: 'preview',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Preview.vue'),
    },
    {
      path: '/activity/integration',
      name: 'integration',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Integration.vue'),
    },
    {
      path: '/activity/settingActivity',
      name: 'settingActivity',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/SettingActivity.vue'),
    },
    {
      path: '/activity/MainInformation',
      name: 'MainInformation',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/MainInformation.vue'),
    },
    {
      path: '/activity/summary',
      name: 'summary',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Summary.vue'),
    },
    {
      path: '/activity/tickets',
      name: 'tickets',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Tickets.vue'),
    },
    {
      path: '/activity/sales',
      name: 'sales',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Sales.vue'),
    },
    {
      path: '/activity/NewAddTicket',
      name: 'NewAddTicket',
      meta: {
        child: true,
      },
      component: () => import('./views/activity/NewAddTicket.vue'),
    },
    {
      path: '/activity/NewAddRow',
      name: 'NewAddRow',
      meta: {
        child: true,
      },
      component: () => import('./views/activity/NewAddRow.vue'),
    },
    {
      path: '/activity/addTickets',
      name: 'addTickets',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/addTickets.vue'),
    },
    {
      path: '/activity/setting',
      name: 'setting',
      meta: {
        child: true,
      },
      component: () => import('./views/activity/Setting.vue'),
    },
    {
      path: '/activity/nosheme',
      name: 'nosheme',
      meta: {
        child: true,
      },
      component: () => import('./views/activity/NoSheme.vue'),
    },
    {
      path: '/activity/settingScan',
      name: 'settingScan',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/SettingScan.vue'),
    },
    {
      path: '/activity/PromoNew',
      name: 'promoNew',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/PromoNew.vue'),
    },
    {
      path: '/activity/NewField',
      name: 'newField',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/NewField.vue'),
    },
    {
      path: '/activity/Orders',
      name: 'orders',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Orders.vue'),
    },
    {
      path: '/activity/Promo',
      name: 'promo',
      meta: {
        layout: 'sidebar',
        child: true,
      },
      component: () => import('./views/activity/Promo.vue'),
    },

  ]
})
